module.exports = __webpack_public_path__ + "static/robesnmore-info-fb0e783323766d2a06dcef5dc3111546.png";